import React from 'react';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import { openNewWindow, setDash, setDetailPageUrl, setNumberWithComma } from '../../../../lib/common';
import Anchor from '../../../../components/link/Anchor';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../constants/service/app/accountUserConstants';

/**
 *  레퍼럴 발급 리스트 컬럼
 */
export const columns = (data) => {
  const { sortOption } = data;

  return [
    {
      title: <TableColumnTitle title={'유저 ID'} />,
      dataIndex: 'referralUserId',
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, value) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.POINT_INFO}`,
            )
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'유저명'} />,
      dataIndex: 'userName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'친구 추천 코드'} />,
      dataIndex: 'referralCode',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'친구 추천 받은 횟수'} />,
      dataIndex: 'referralCount',
      sorter: true,
      sortOrder: sortOption['referralCount'],
    },
    {
      title: <TableColumnTitle title={'친구 추천으로 받은 포인트'} />,
      dataIndex: 'referralAmount',
      render: (value) => setNumberWithComma(value),
      sorter: true,
      sortOrder: sortOption['referralAmount'],
    },
    {
      title: <TableColumnTitle title={'기간 내 받은 포인트'} />,
      dataIndex: 'totalCredit',
      render: (value) => setNumberWithComma(value),
      sorter: true,
      sortOrder: sortOption['totalCredit'],
    },
    {
      title: <TableColumnTitle title={'기간 내 사용한 포인트'} />,
      dataIndex: 'totalUsedCredit',
      render: (value) => setNumberWithComma(value),
      sorter: true,
      sortOrder: sortOption['totalUsedCredit'],
    },
  ];
};
